import { handleApiResponse } from '../utils/handleApi';
const isServer = typeof window === 'undefined';

const serviceYoutubeEndpoint = 'https://youtube.s-prod.pow.io';

export const getPlaylistData = async (playlistId) => {
	if (isServer) {
		throw new Error('Trying to call service-youtube server-side');
	}

	if (!playlistId) {
		throw new Error('No playlist id given');
	}

	return fetch(`${serviceYoutubeEndpoint}/getPlaylistData?playlistId=${playlistId}`)
		.then(handleApiResponse);
};
